import React, { Component } from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import styled from "styled-components";
import { Link } from "react-router-dom";

class ModelOfMandub extends Component {
  render() {
    return (
      <ProductConsumer>
        {(value) => {
          const {
            RMM_openmodel,
            RMM_CloseModal,
            RMM_peshandan,
            AddProChange,
            RMM_from,
            RMM_to,
            RPD_peshandan
          } = value;

          if (!RMM_openmodel) {
            return null;
          } else {
            return (
              <ModalContainer>
                <div className="container">
                  <div className="row">
                    <div
                      id="modal"
                      className="col-8 mx-auto col-10 col-lg-7 text-center text-capitalize p-5"
                    >
                      <div className="row">
                        <div className="col-12 mb2">
                          <h3>مافی.کۆمپانیا</h3>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-6">
                          <div className="form-group">
                            <label className="text-danger f3 font-weight-bold">
                              هەتاوەکو
                            </label>
                            <br />
                            <input
                              type="date"
                              onChange={AddProChange}
                              name="RMM_to"
                              value={RMM_to}
                              className="selectpicker btn btn-dark f4"
                            />
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="form-group">
                            <label className="text-danger f3 font-weight-bold">
                              لە
                            </label>
                            <br />
                            <input
                              type="date"
                              onChange={AddProChange}
                              name="RMM_from"
                              value={RMM_from}
                              className="selectpicker btn btn-dark f4"
                            />
                          </div>
                        </div>
                      </div>
                      <br />
                      <div className="row">
                        <div className="col-6">
                          <Link to="/Product-Raport">
                            <button
                              className="btn btn-success"
                              onClick={() => RMM_CloseModal()}
                            >
                              چوونەدەرەوە
                            </button>
                          </Link>
                        </div>
                        <div className="col-6">
                          <Link to="/raporty-mandubakan">
                            <button
                              className="btn btn-info"
                              onClick={RMM_peshandan}
                            >
                              پیشاندان
                            </button>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ModalContainer>
            );
          }
        }}
      </ProductConsumer>
    );
  }
}

const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  #modal {
    background: #f3e29f;
  }
`;

export default ModelOfMandub;
